<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card class="referral-dialog">
    <nb-card-header>
      <h4>
        {{
          (agreement ? "dialogs.referralAgreement.titleEdit" : "dialogs.referralAgreement.titleCreate")
            | translate
        }}
      </h4>
    </nb-card-header>

    <nb-card-body>
      <div class="grid">
        <label class="label">{{ "dialogs.referralAgreement.client" | translate }}</label>
        <div class="field">
          @if (agreement) {
            <span class="fixed">{{ agreement.client_name }}</span>
          } @else {
            <input
              nbInput
              fullWidth
              size="small"
              data-enter-ignore
              [placeholder]="'dialogs.referralAgreement.clientFilter' | translate"
              [(ngModel)]="clientFilter"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="applyClientFilter()"
            />
            <nb-select
              fullWidth
              formControlName="client_id"
              [placeholder]="'dialogs.referralAgreement.clientPlaceholder' | translate"
            >
              @for (c of filteredClients; track c.id) {
                <nb-option [value]="c.id">{{ clientLabel(c) }}</nb-option>
              }
            </nb-select>
            @if (!clients.length) {
              <p class="hint">{{ "dialogs.referralAgreement.noEligible" | translate }}</p>
            }
          }
        </div>

        <label class="label">{{ "dialogs.referralAgreement.partner" | translate }}</label>
        <div class="field">
          <nb-select fullWidth formControlName="partner_id">
            @for (p of partners; track p.id) {
              <nb-option [value]="p.id">{{ p.name }}</nb-option>
            }
          </nb-select>
        </div>

        <label class="label">{{ "dialogs.referralAgreement.start" | translate }}</label>
        <div class="field">
          <input nbInput fullWidth type="date" formControlName="start_date" />
        </div>

        <label class="label">{{ "dialogs.referralAgreement.end" | translate }}</label>
        <div class="field">
          <input nbInput fullWidth type="date" formControlName="end_date" />
          <p class="hint">{{ "dialogs.referralAgreement.endHint" | translate }}</p>
        </div>

        <label class="label">{{ "dialogs.referralAgreement.basis" | translate }}</label>
        <div class="field">
          <span class="fixed">{{ "dialogs.referralAgreement.basisNet" | translate }}</span>
          <p class="hint">{{ "dialogs.referralAgreement.basisHint" | translate }}</p>
        </div>
      </div>

      <section class="tile-flat">
        <header class="tile-flat__header">
          <h5>{{ "dialogs.referralAgreement.tiers" | translate }}</h5>
        </header>
        <p class="hint">{{ "dialogs.referralAgreement.tiersHint" | translate }}</p>
        <div formArrayName="tiers" class="tiers">
          @for (t of tiers.controls; track $index; let i = $index) {
            <div class="tier" [formGroupName]="i">
              <span>{{ "dialogs.referralAgreement.fromMonth" | translate }}</span>
              <input nbInput size="small" type="number" min="1" formControlName="from_month" />
              <span>{{ "dialogs.referralAgreement.toMonth" | translate }}</span>
              <input
                nbInput
                size="small"
                type="number"
                min="1"
                formControlName="to_month"
                [placeholder]="'dialogs.referralAgreement.openEnd' | translate"
              />
              <input nbInput size="small" type="number" min="0" max="100" step="0.5" formControlName="percent" />
              <span>%</span>
              <button
                type="button"
                nbButton
                ghost
                size="small"
                [disabled]="tiers.length <= 1"
                (click)="removeTier(i)"
                [attr.aria-label]="'dialogs.referralAgreement.removeTier' | translate"
              >
                <nb-icon icon="trash-2-outline"></nb-icon>
              </button>
            </div>
          }
        </div>
        <button type="button" nbButton ghost size="small" (click)="addTier()">
          <nb-icon icon="plus-outline"></nb-icon>
          {{ "dialogs.referralAgreement.addTier" | translate }}
        </button>
      </section>

      <div class="grid">
        <label class="label">{{ "dialogs.referralAgreement.note" | translate }}</label>
        <div class="field">
          <textarea nbInput fullWidth rows="2" formControlName="note"></textarea>
        </div>
      </div>
    </nb-card-body>

    <nb-card-footer>
      <button type="button" nbButton status="danger" outline (click)="dialogRef.close()">
        {{ "buttons.cancel" | translate }}
      </button>
      <button type="submit" nbButton status="primary" [disabled]="saving">
        {{ "buttons.save" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
